export var vueCustomElementOptions = {
    // 'constructorCallback' can be triggered multiple times when e.g. vue-router is used
    constructorCallback: function () {
        // remove class that hides content elements until loaded properly
    },
    // element is mounted/inserted into document
    connectedCallback: function () {
        this.classList.remove('u-hide');
    },
    // element is removed from document
    disconnectedCallback: function () {
    },
    // one of element's attributes (Vue instance props) is changed
    attributeChangedCallback: function (name, oldValue, value) {
    },
    // in case of using vue-custom-element with modals, we destroy  it after defined timeout
    destroyTimeout: 3000,
    // only needed when using lazy-loading - 'props' are not accessible on Custom Element registration so we have to provide them
    props: [],
    // you can set shadow root for element. Only works if native implementation is available.
    shadow: false,
    // you can set CSS that will be available in Shadow DOM.
    shadowCss: ''
};
